/**
 * Configuration centralisée de l'application
 */

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 
    (import.meta.env.DEV 
      ? 'http://localhost:3000/api/v1' 
      : 'https://api.agronovamed.com/api/v1'),
  TIMEOUT: 30000, // 30 secondes
} as const

export const APP_CONFIG = {
  NAME: 'AGRO NOVAMED',
  VERSION: '3.0.0',
  TITLE: 'AGRO NOVAMED - Gestion de Ferme',
} as const

export const ROUTES = {
  LOGIN: '/auth/login',
  DASHBOARD: '/dashboard',
  BANDES: '/bandes',
  FINANCES: '/finances',
  STOCKS: '/stocks',
  RH: '/rh',
  CRM: '/crm',
} as const

